<template>
  <table
    class="common-table"
  >
    <tbody>
      <slot></slot>
    </tbody>
  </table>
</template>

<script>

export default {
  name: 'CommonTable',
};
</script>

<style lang="scss" scoped>
.common-table {
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 28px;
  text-align: left;
  word-break: break-all;
}

tr {
  background: white;
  &:nth-child(even) {
    background: #f9f9f9;
  }
  &:last-child td{
    padding-bottom: 0;
  }
}

th {
  position: sticky;
  top: 0;
  z-index: 2;
  color: rgba(0,0,0,0.42);
  background: #fff;
  padding: 18px;
  min-width: 100px;
  vertical-align: middle;
  &:first-child{
    left: 0;
  }
}

td {
  padding: 18px;
  color: rgba(0,0,0,0.84);
  &:first-child {
    position:sticky;
    left:0;
    z-index: 1;
  }
  &.like-a {
    color: rgb(10, 112, 245);
    text-decoration: underline;
  }
}

</style>
